// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, useMutation, type UseMutationOptions, useQuery } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptAdminsToChargeSystem, acceptFacilityChargeSystemSetup, acceptHomeChargeSystemSetup, alterRfidAccess, alterUserAccess, changeAdminPassword, changeAvailabilityForConnectors, checkAuthentication, checkInvite, clearDisplayMessage, createAutomaticReport, createConnectorGroup, createRfid, createToken, deleteAutomaticReport, deleteConnectorGroup, deleteKeyAccessToChargeSystem, deleteRfid, deleteUserAccessToChargeSystem, editRfidKeyName, getAdminById, getAutomaticReport, getAutomaticReports, getChargeSystemAlertGroups, getChargeSystemConnectors, getChargeSystemImd, getChargeSystemImdUsers, getChargeSystemSetupInfo, getInvoice, getInvoices, getInvoicesOutstandingAmounts, getLoggedInAdmin, getOrganizationAdmins, getOrganizationInvitedAdmins, getP3InvitedUsers, getP3User, getP3Users, getPassTokenValid, getReport, getReports, getRfidUsers, getVariables, inviteAdmins, inviteUserToChargeSystem, listAdmins, listChargeSystems, listConnectorStatuses, login, type Options, passWordReset, removeAdminAccess, resendUserInvite, resetChargePoint, revokeAdminInvite, revokeUserInviteToChargeSystem, setChargeSystemChargersToDefault, setChargeSystemImd, setChargeSystemImdUser, setChargeSystemInvoicing, setDiscountForUser, setDisplayMessage, setP3LiveConsumption, setUserInvoicing, startCharging, startPingCharger, statusHistory, stopCharging, stopPingCharger, updateAutomaticReport, updateChargeSystemAlertGroup, updateChargeSystemConnector, updateConnectorGroup, updateConnectorGroups, updateLoggedInAdmin } from '../sdk.gen';
import type { AcceptAdminsToChargeSystemData, AcceptFacilityChargeSystemSetupData, AcceptFacilityChargeSystemSetupError, AcceptFacilityChargeSystemSetupResponse, AcceptHomeChargeSystemSetupData, AcceptHomeChargeSystemSetupError, AcceptHomeChargeSystemSetupResponse, AlterRfidAccessData, AlterUserAccessData, ChangeAdminPasswordData, ChangeAvailabilityForConnectorsData, CheckAuthenticationData, CheckInviteData, ClearDisplayMessageData, CreateAutomaticReportData, CreateConnectorGroupData, CreateRfidData, CreateTokenData, DeleteAutomaticReportData, DeleteConnectorGroupData, DeleteKeyAccessToChargeSystemData, DeleteRfidData, DeleteUserAccessToChargeSystemData, EditRfidKeyNameData, GetAdminByIdData, GetAdminByIdResponse, GetAutomaticReportData, GetAutomaticReportsData, GetChargeSystemAlertGroupsData, GetChargeSystemConnectorsData, GetChargeSystemConnectorsResponse, GetChargeSystemImdData, GetChargeSystemImdUsersData, GetChargeSystemSetupInfoData, GetChargeSystemSetupInfoError, GetChargeSystemSetupInfoResponse, GetInvoiceData, GetInvoiceResponse, GetInvoicesData, GetInvoicesOutstandingAmountsData, GetInvoicesOutstandingAmountsResponse, GetInvoicesResponse, GetLoggedInAdminData, GetLoggedInAdminResponse, GetOrganizationAdminsData, GetOrganizationAdminsResponse, GetOrganizationInvitedAdminsData, GetOrganizationInvitedAdminsResponse, GetP3InvitedUsersData, GetP3InvitedUsersError, GetP3InvitedUsersResponse, GetP3UserData, GetP3UserError, GetP3UserResponse, GetP3UsersData, GetP3UsersError, GetP3UsersResponse, GetPassTokenValidData, GetReportData, GetReportsData, GetRfidUsersData, GetVariablesData, InviteAdminsData, InviteUserToChargeSystemData, ListAdminsData, ListAdminsResponse, ListChargeSystemsData, ListChargeSystemsResponse, ListConnectorStatusesData, ListConnectorStatusesResponse2, LoginData, PassWordResetData, RemoveAdminAccessData, ResendUserInviteData, ResetChargePointData, RevokeAdminInviteData, RevokeUserInviteToChargeSystemData, SetChargeSystemChargersToDefaultData, SetChargeSystemImdData, SetChargeSystemImdUserData, SetChargeSystemInvoicingData, SetDiscountForUserData, SetDisplayMessageData, SetP3LiveConsumptionData, SetUserInvoicingData, StartChargingData, StartPingChargerData, StatusHistoryData, StatusHistoryResponse, StopChargingData, StopPingChargerData, UpdateAutomaticReportData, UpdateChargeSystemAlertGroupData, UpdateChargeSystemConnectorData, UpdateConnectorGroupData, UpdateConnectorGroupsData, UpdateLoggedInAdminData, UpdateLoggedInAdminResponse } from '../types.gen';

/**
 * Remove admin access for organization
 */
export const removeAdminAccessMutation = (options?: Partial<Options<RemoveAdminAccessData>>): UseMutationOptions<unknown, DefaultError, Options<RemoveAdminAccessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<RemoveAdminAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeAdminAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove admin access for organization
 */
export const useRemoveAdminAccessMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<RemoveAdminAccessData>>, 'mutationFn'>>) => useMutation({ ...removeAdminAccessMutation(), ...mutationOptions });

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getLoggedInAdminQueryKey = (options?: Options<GetLoggedInAdminData>) => createQueryKey('getLoggedInAdmin', options);

/**
 * Get admin data of the logged in admin
 */
export const getLoggedInAdminQueryOptions = (options?: Options<GetLoggedInAdminData>) => queryOptions<GetLoggedInAdminResponse, DefaultError, GetLoggedInAdminResponse, ReturnType<typeof getLoggedInAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLoggedInAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLoggedInAdminQueryKey(options)
});

/**
 * Get admin data of the logged in admin
 */
export const useGetLoggedInAdminQuery = (options?: Options<GetLoggedInAdminData>) => useQuery(getLoggedInAdminQueryOptions(options));

/**
 * Update data of the logged in admin
 */
export const updateLoggedInAdminMutation = (options?: Partial<Options<UpdateLoggedInAdminData>>): UseMutationOptions<UpdateLoggedInAdminResponse, DefaultError, Options<UpdateLoggedInAdminData>> => {
    const mutationOptions: UseMutationOptions<UpdateLoggedInAdminResponse, DefaultError, Options<UpdateLoggedInAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLoggedInAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update data of the logged in admin
 */
export const useUpdateLoggedInAdminMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<UpdateLoggedInAdminResponse, DefaultError, Options<UpdateLoggedInAdminData>>, 'mutationFn'>>) => useMutation({ ...updateLoggedInAdminMutation(), ...mutationOptions });

/**
 * Change the password of the logged in admin
 */
export const changeAdminPasswordMutation = (options?: Partial<Options<ChangeAdminPasswordData>>): UseMutationOptions<unknown, DefaultError, Options<ChangeAdminPasswordData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ChangeAdminPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeAdminPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change the password of the logged in admin
 */
export const useChangeAdminPasswordMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<ChangeAdminPasswordData>>, 'mutationFn'>>) => useMutation({ ...changeAdminPasswordMutation(), ...mutationOptions });

export const listAdminsQueryKey = (options?: Options<ListAdminsData>) => createQueryKey('listAdmins', options);

/**
 * List admins visible to the logged in admin
 */
export const listAdminsQueryOptions = (options?: Options<ListAdminsData>) => queryOptions<ListAdminsResponse, DefaultError, ListAdminsResponse, ReturnType<typeof listAdminsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAdmins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAdminsQueryKey(options)
});

/**
 * List admins visible to the logged in admin
 */
export const useListAdminsQuery = (options?: Options<ListAdminsData>) => useQuery(listAdminsQueryOptions(options));

export const getAdminByIdQueryKey = (options: Options<GetAdminByIdData>) => createQueryKey('getAdminById', options);

/**
 * Get admin by id when visible to the logged in admin
 */
export const getAdminByIdQueryOptions = (options: Options<GetAdminByIdData>) => queryOptions<GetAdminByIdResponse, DefaultError, GetAdminByIdResponse, ReturnType<typeof getAdminByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminByIdQueryKey(options)
});

/**
 * Get admin by id when visible to the logged in admin
 */
export const useGetAdminByIdQuery = (options: Options<GetAdminByIdData>) => useQuery(getAdminByIdQueryOptions(options));

/**
 * Add email to anonymous admin and create ChargesystemSetup
 *
 * Add email to anonymous admin and create ChargesystemSetup
 */
export const acceptFacilityChargeSystemSetupMutation = (options?: Partial<Options<AcceptFacilityChargeSystemSetupData>>): UseMutationOptions<AcceptFacilityChargeSystemSetupResponse, AcceptFacilityChargeSystemSetupError, Options<AcceptFacilityChargeSystemSetupData>> => {
    const mutationOptions: UseMutationOptions<AcceptFacilityChargeSystemSetupResponse, AcceptFacilityChargeSystemSetupError, Options<AcceptFacilityChargeSystemSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptFacilityChargeSystemSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add email to anonymous admin and create ChargesystemSetup
 *
 * Add email to anonymous admin and create ChargesystemSetup
 */
export const useAcceptFacilityChargeSystemSetupMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<AcceptFacilityChargeSystemSetupResponse, AcceptFacilityChargeSystemSetupError, Options<AcceptFacilityChargeSystemSetupData>>, 'mutationFn'>>) => useMutation({ ...acceptFacilityChargeSystemSetupMutation(), ...mutationOptions });

/**
 * Add phone number to anonymous admin and create ChargesystemSetup
 *
 * Add phone number to anonymous admin and create ChargesystemSetup
 */
export const acceptHomeChargeSystemSetupMutation = (options?: Partial<Options<AcceptHomeChargeSystemSetupData>>): UseMutationOptions<AcceptHomeChargeSystemSetupResponse, AcceptHomeChargeSystemSetupError, Options<AcceptHomeChargeSystemSetupData>> => {
    const mutationOptions: UseMutationOptions<AcceptHomeChargeSystemSetupResponse, AcceptHomeChargeSystemSetupError, Options<AcceptHomeChargeSystemSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptHomeChargeSystemSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add phone number to anonymous admin and create ChargesystemSetup
 *
 * Add phone number to anonymous admin and create ChargesystemSetup
 */
export const useAcceptHomeChargeSystemSetupMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<AcceptHomeChargeSystemSetupResponse, AcceptHomeChargeSystemSetupError, Options<AcceptHomeChargeSystemSetupData>>, 'mutationFn'>>) => useMutation({ ...acceptHomeChargeSystemSetupMutation(), ...mutationOptions });

export const getChargeSystemSetupInfoQueryKey = (options: Options<GetChargeSystemSetupInfoData>) => createQueryKey('getChargeSystemSetupInfo', options);

/**
 * Get information about the ChargesystemSetup
 *
 * Get information about the ChargesystemSetup
 */
export const getChargeSystemSetupInfoQueryOptions = (options: Options<GetChargeSystemSetupInfoData>) => queryOptions<GetChargeSystemSetupInfoResponse, GetChargeSystemSetupInfoError, GetChargeSystemSetupInfoResponse, ReturnType<typeof getChargeSystemSetupInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChargeSystemSetupInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChargeSystemSetupInfoQueryKey(options)
});

/**
 * Get information about the ChargesystemSetup
 *
 * Get information about the ChargesystemSetup
 */
export const useGetChargeSystemSetupInfoQuery = (options: Options<GetChargeSystemSetupInfoData>) => useQuery(getChargeSystemSetupInfoQueryOptions(options));

export const checkAuthenticationQueryKey = (options?: Options<CheckAuthenticationData>) => createQueryKey('checkAuthentication', options);

/**
 * check if correct header
 */
export const checkAuthenticationQueryOptions = (options?: Options<CheckAuthenticationData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof checkAuthenticationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkAuthentication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkAuthenticationQueryKey(options)
});

/**
 * check if correct header
 */
export const useCheckAuthenticationQuery = (options?: Options<CheckAuthenticationData>) => useQuery(checkAuthenticationQueryOptions(options));

export const getChargeSystemAlertGroupsQueryKey = (options: Options<GetChargeSystemAlertGroupsData>) => createQueryKey('getChargeSystemAlertGroups', options);

/**
 * get all alert groups
 *
 * get all alert groups
 */
export const getChargeSystemAlertGroupsQueryOptions = (options: Options<GetChargeSystemAlertGroupsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getChargeSystemAlertGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChargeSystemAlertGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChargeSystemAlertGroupsQueryKey(options)
});

/**
 * get all alert groups
 *
 * get all alert groups
 */
export const useGetChargeSystemAlertGroupsQuery = (options: Options<GetChargeSystemAlertGroupsData>) => useQuery(getChargeSystemAlertGroupsQueryOptions(options));

/**
 * Modifies members of the charge system alert group
 */
export const updateChargeSystemAlertGroupMutation = (options?: Partial<Options<UpdateChargeSystemAlertGroupData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateChargeSystemAlertGroupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateChargeSystemAlertGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChargeSystemAlertGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Modifies members of the charge system alert group
 */
export const useUpdateChargeSystemAlertGroupMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<UpdateChargeSystemAlertGroupData>>, 'mutationFn'>>) => useMutation({ ...updateChargeSystemAlertGroupMutation(), ...mutationOptions });

/**
 * clear display message
 *
 * clear display message
 */
export const clearDisplayMessageMutation = (options?: Partial<Options<ClearDisplayMessageData>>): UseMutationOptions<unknown, DefaultError, Options<ClearDisplayMessageData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ClearDisplayMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearDisplayMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * clear display message
 *
 * clear display message
 */
export const useClearDisplayMessageMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<ClearDisplayMessageData>>, 'mutationFn'>>) => useMutation({ ...clearDisplayMessageMutation(), ...mutationOptions });

/**
 * set display message
 *
 * set display message
 */
export const setDisplayMessageMutation = (options?: Partial<Options<SetDisplayMessageData>>): UseMutationOptions<unknown, DefaultError, Options<SetDisplayMessageData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetDisplayMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDisplayMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * set display message
 *
 * set display message
 */
export const useSetDisplayMessageMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetDisplayMessageData>>, 'mutationFn'>>) => useMutation({ ...setDisplayMessageMutation(), ...mutationOptions });

/**
 * reset chargepoint
 *
 * reset chargepoint
 */
export const resetChargePointMutation = (options?: Partial<Options<ResetChargePointData>>): UseMutationOptions<unknown, DefaultError, Options<ResetChargePointData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ResetChargePointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetChargePoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * reset chargepoint
 *
 * reset chargepoint
 */
export const useResetChargePointMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<ResetChargePointData>>, 'mutationFn'>>) => useMutation({ ...resetChargePointMutation(), ...mutationOptions });

/**
 * Update connector
 *
 * Update a chargesystems connector
 */
export const updateChargeSystemConnectorMutation = (options?: Partial<Options<UpdateChargeSystemConnectorData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateChargeSystemConnectorData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateChargeSystemConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChargeSystemConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update connector
 *
 * Update a chargesystems connector
 */
export const useUpdateChargeSystemConnectorMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<UpdateChargeSystemConnectorData>>, 'mutationFn'>>) => useMutation({ ...updateChargeSystemConnectorMutation(), ...mutationOptions });

export const statusHistoryQueryKey = (options: Options<StatusHistoryData>) => createQueryKey('statusHistory', options);

/**
 * get status history
 *
 * get status history
 */
export const statusHistoryQueryOptions = (options: Options<StatusHistoryData>) => queryOptions<StatusHistoryResponse, DefaultError, StatusHistoryResponse, ReturnType<typeof statusHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statusHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statusHistoryQueryKey(options)
});

/**
 * get status history
 *
 * get status history
 */
export const useStatusHistoryQuery = (options: Options<StatusHistoryData>) => useQuery(statusHistoryQueryOptions(options));

export const getChargeSystemConnectorsQueryKey = (options: Options<GetChargeSystemConnectorsData>) => createQueryKey('getChargeSystemConnectors', options);

/**
 * Get charge system connectors
 *
 * Get all connectors for a charge system
 */
export const getChargeSystemConnectorsQueryOptions = (options: Options<GetChargeSystemConnectorsData>) => queryOptions<GetChargeSystemConnectorsResponse, DefaultError, GetChargeSystemConnectorsResponse, ReturnType<typeof getChargeSystemConnectorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChargeSystemConnectors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChargeSystemConnectorsQueryKey(options)
});

/**
 * Get charge system connectors
 *
 * Get all connectors for a charge system
 */
export const useGetChargeSystemConnectorsQuery = (options: Options<GetChargeSystemConnectorsData>) => useQuery(getChargeSystemConnectorsQueryOptions(options));

/**
 * Enabled or disabled live consumption for a chargeSystem
 *
 * Enabled or disabled live consumption for a chargeSystem
 */
export const setP3LiveConsumptionMutation = (options?: Partial<Options<SetP3LiveConsumptionData>>): UseMutationOptions<unknown, DefaultError, Options<SetP3LiveConsumptionData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetP3LiveConsumptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setP3LiveConsumption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enabled or disabled live consumption for a chargeSystem
 *
 * Enabled or disabled live consumption for a chargeSystem
 */
export const useSetP3LiveConsumptionMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetP3LiveConsumptionData>>, 'mutationFn'>>) => useMutation({ ...setP3LiveConsumptionMutation(), ...mutationOptions });

export const setChargeSystemChargersToDefaultQueryKey = (options: Options<SetChargeSystemChargersToDefaultData>) => createQueryKey('setChargeSystemChargersToDefault', options);

/**
 * Set chargesystem connectors to a default state
 *
 * Set chargesystem connectors to a default state
 */
export const setChargeSystemChargersToDefaultQueryOptions = (options: Options<SetChargeSystemChargersToDefaultData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof setChargeSystemChargersToDefaultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await setChargeSystemChargersToDefault({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: setChargeSystemChargersToDefaultQueryKey(options)
});

/**
 * Set chargesystem connectors to a default state
 *
 * Set chargesystem connectors to a default state
 */
export const useSetChargeSystemChargersToDefaultQuery = (options: Options<SetChargeSystemChargersToDefaultData>) => useQuery(setChargeSystemChargersToDefaultQueryOptions(options));

/**
 * set user discount to chargeSystem
 *
 * set user discount to chargeSystem
 */
export const setDiscountForUserMutation = (options?: Partial<Options<SetDiscountForUserData>>): UseMutationOptions<unknown, DefaultError, Options<SetDiscountForUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetDiscountForUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDiscountForUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * set user discount to chargeSystem
 *
 * set user discount to chargeSystem
 */
export const useSetDiscountForUserMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetDiscountForUserData>>, 'mutationFn'>>) => useMutation({ ...setDiscountForUserMutation(), ...mutationOptions });

export const getChargeSystemImdQueryKey = (options: Options<GetChargeSystemImdData>) => createQueryKey('getChargeSystemImd', options);

/**
 * get charge-system imd
 *
 * get charge-system imd
 */
export const getChargeSystemImdQueryOptions = (options: Options<GetChargeSystemImdData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getChargeSystemImdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChargeSystemImd({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChargeSystemImdQueryKey(options)
});

/**
 * get charge-system imd
 *
 * get charge-system imd
 */
export const useGetChargeSystemImdQuery = (options: Options<GetChargeSystemImdData>) => useQuery(getChargeSystemImdQueryOptions(options));

/**
 * set charge-system imd
 *
 * set charge-system imd
 */
export const setChargeSystemImdMutation = (options?: Partial<Options<SetChargeSystemImdData>>): UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemImdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemImdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setChargeSystemImd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * set charge-system imd
 *
 * set charge-system imd
 */
export const useSetChargeSystemImdMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemImdData>>, 'mutationFn'>>) => useMutation({ ...setChargeSystemImdMutation(), ...mutationOptions });

export const getChargeSystemImdUsersQueryKey = (options: Options<GetChargeSystemImdUsersData>) => createQueryKey('getChargeSystemImdUsers', options);

/**
 * Gets all charge-system imd user invoice reference
 *
 * Gets all charge-system imd user invoice reference
 */
export const getChargeSystemImdUsersQueryOptions = (options: Options<GetChargeSystemImdUsersData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getChargeSystemImdUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChargeSystemImdUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChargeSystemImdUsersQueryKey(options)
});

/**
 * Gets all charge-system imd user invoice reference
 *
 * Gets all charge-system imd user invoice reference
 */
export const useGetChargeSystemImdUsersQuery = (options: Options<GetChargeSystemImdUsersData>) => useQuery(getChargeSystemImdUsersQueryOptions(options));

/**
 * Update charge-system imd user invoice reference
 *
 * Update charge-system imd user invoice reference
 */
export const setChargeSystemImdUserMutation = (options?: Partial<Options<SetChargeSystemImdUserData>>): UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemImdUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemImdUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setChargeSystemImdUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update charge-system imd user invoice reference
 *
 * Update charge-system imd user invoice reference
 */
export const useSetChargeSystemImdUserMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemImdUserData>>, 'mutationFn'>>) => useMutation({ ...setChargeSystemImdUserMutation(), ...mutationOptions });

/**
 * set charge-system invoicing
 *
 * set charge-system invoicing
 */
export const setChargeSystemInvoicingMutation = (options?: Partial<Options<SetChargeSystemInvoicingData>>): UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemInvoicingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemInvoicingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setChargeSystemInvoicing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * set charge-system invoicing
 *
 * set charge-system invoicing
 */
export const useSetChargeSystemInvoicingMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetChargeSystemInvoicingData>>, 'mutationFn'>>) => useMutation({ ...setChargeSystemInvoicingMutation(), ...mutationOptions });

/**
 * set user invoicing
 *
 * set user invoicing
 */
export const setUserInvoicingMutation = (options?: Partial<Options<SetUserInvoicingData>>): UseMutationOptions<unknown, DefaultError, Options<SetUserInvoicingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetUserInvoicingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUserInvoicing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * set user invoicing
 *
 * set user invoicing
 */
export const useSetUserInvoicingMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<SetUserInvoicingData>>, 'mutationFn'>>) => useMutation({ ...setUserInvoicingMutation(), ...mutationOptions });

/**
 * Alter user access for the charge system
 */
export const alterUserAccessMutation = (options?: Partial<Options<AlterUserAccessData>>): UseMutationOptions<unknown, DefaultError, Options<AlterUserAccessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AlterUserAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await alterUserAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Alter user access for the charge system
 */
export const useAlterUserAccessMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<AlterUserAccessData>>, 'mutationFn'>>) => useMutation({ ...alterUserAccessMutation(), ...mutationOptions });

/**
 * revoke user invite chargesystems
 */
export const revokeUserInviteToChargeSystemMutation = (options?: Partial<Options<RevokeUserInviteToChargeSystemData>>): UseMutationOptions<unknown, DefaultError, Options<RevokeUserInviteToChargeSystemData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<RevokeUserInviteToChargeSystemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeUserInviteToChargeSystem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * revoke user invite chargesystems
 */
export const useRevokeUserInviteToChargeSystemMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<RevokeUserInviteToChargeSystemData>>, 'mutationFn'>>) => useMutation({ ...revokeUserInviteToChargeSystemMutation(), ...mutationOptions });

/**
 * invite users to a chargesystems
 */
export const inviteUserToChargeSystemMutation = (options?: Partial<Options<InviteUserToChargeSystemData>>): UseMutationOptions<unknown, DefaultError, Options<InviteUserToChargeSystemData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InviteUserToChargeSystemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inviteUserToChargeSystem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * invite users to a chargesystems
 */
export const useInviteUserToChargeSystemMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<InviteUserToChargeSystemData>>, 'mutationFn'>>) => useMutation({ ...inviteUserToChargeSystemMutation(), ...mutationOptions });

/**
 * resend user invites for charge system
 */
export const resendUserInviteMutation = (options?: Partial<Options<ResendUserInviteData>>): UseMutationOptions<unknown, DefaultError, Options<ResendUserInviteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ResendUserInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendUserInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * resend user invites for charge system
 */
export const useResendUserInviteMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<ResendUserInviteData>>, 'mutationFn'>>) => useMutation({ ...resendUserInviteMutation(), ...mutationOptions });

/**
 * Delete user access from charge system
 */
export const deleteKeyAccessToChargeSystemMutation = (options?: Partial<Options<DeleteKeyAccessToChargeSystemData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteKeyAccessToChargeSystemData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteKeyAccessToChargeSystemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteKeyAccessToChargeSystem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete user access from charge system
 */
export const useDeleteKeyAccessToChargeSystemMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<DeleteKeyAccessToChargeSystemData>>, 'mutationFn'>>) => useMutation({ ...deleteKeyAccessToChargeSystemMutation(), ...mutationOptions });

/**
 * Delete user access from charge system
 */
export const deleteUserAccessToChargeSystemMutation = (options?: Partial<Options<DeleteUserAccessToChargeSystemData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteUserAccessToChargeSystemData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteUserAccessToChargeSystemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserAccessToChargeSystem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete user access from charge system
 */
export const useDeleteUserAccessToChargeSystemMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<DeleteUserAccessToChargeSystemData>>, 'mutationFn'>>) => useMutation({ ...deleteUserAccessToChargeSystemMutation(), ...mutationOptions });

export const listChargeSystemsQueryKey = (options?: Options<ListChargeSystemsData>) => createQueryKey('listChargeSystems', options);

/**
 * List accessible charge systems
 *
 * List all charge systems the admin has access to, including non-RFID user ids per charge system
 */
export const listChargeSystemsQueryOptions = (options?: Options<ListChargeSystemsData>) => queryOptions<ListChargeSystemsResponse, DefaultError, ListChargeSystemsResponse, ReturnType<typeof listChargeSystemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChargeSystems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChargeSystemsQueryKey(options)
});

/**
 * List accessible charge systems
 *
 * List all charge systems the admin has access to, including non-RFID user ids per charge system
 */
export const useListChargeSystemsQuery = (options?: Options<ListChargeSystemsData>) => useQuery(listChargeSystemsQueryOptions(options));

/**
 * Start charging
 */
export const startChargingMutation = (options?: Partial<Options<StartChargingData>>): UseMutationOptions<unknown, DefaultError, Options<StartChargingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StartChargingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startCharging({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start charging
 */
export const useStartChargingMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<StartChargingData>>, 'mutationFn'>>) => useMutation({ ...startChargingMutation(), ...mutationOptions });

/**
 * Stop charging
 */
export const stopChargingMutation = (options?: Partial<Options<StopChargingData>>): UseMutationOptions<unknown, DefaultError, Options<StopChargingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StopChargingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopCharging({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop charging
 */
export const useStopChargingMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<StopChargingData>>, 'mutationFn'>>) => useMutation({ ...stopChargingMutation(), ...mutationOptions });

/**
 * Revoke admin invite for organization
 */
export const revokeAdminInviteMutation = (options?: Partial<Options<RevokeAdminInviteData>>): UseMutationOptions<unknown, DefaultError, Options<RevokeAdminInviteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<RevokeAdminInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeAdminInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke admin invite for organization
 */
export const useRevokeAdminInviteMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<RevokeAdminInviteData>>, 'mutationFn'>>) => useMutation({ ...revokeAdminInviteMutation(), ...mutationOptions });

/**
 * invite admins to organizations or charge systems
 */
export const inviteAdminsMutation = (options?: Partial<Options<InviteAdminsData>>): UseMutationOptions<unknown, DefaultError, Options<InviteAdminsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<InviteAdminsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inviteAdmins({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * invite admins to organizations or charge systems
 */
export const useInviteAdminsMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<InviteAdminsData>>, 'mutationFn'>>) => useMutation({ ...inviteAdminsMutation(), ...mutationOptions });

export const getP3InvitedUsersQueryKey = (options?: Options<GetP3InvitedUsersData>) => createQueryKey('getP3InvitedUsers', options);

/**
 * Get all invited app users
 */
export const getP3InvitedUsersQueryOptions = (options?: Options<GetP3InvitedUsersData>) => queryOptions<GetP3InvitedUsersResponse, GetP3InvitedUsersError, GetP3InvitedUsersResponse, ReturnType<typeof getP3InvitedUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getP3InvitedUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getP3InvitedUsersQueryKey(options)
});

/**
 * Get all invited app users
 */
export const useGetP3InvitedUsersQuery = (options?: Options<GetP3InvitedUsersData>) => useQuery(getP3InvitedUsersQueryOptions(options));

export const getInvoicesQueryKey = (options?: Options<GetInvoicesData>) => createQueryKey('getInvoices', options);

/**
 * Get a set of invoices for a charge system
 */
export const getInvoicesQueryOptions = (options?: Options<GetInvoicesData>) => queryOptions<GetInvoicesResponse, DefaultError, GetInvoicesResponse, ReturnType<typeof getInvoicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvoices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvoicesQueryKey(options)
});

/**
 * Get a set of invoices for a charge system
 */
export const useGetInvoicesQuery = (options?: Options<GetInvoicesData>) => useQuery(getInvoicesQueryOptions(options));

export const getInvoicesOutstandingAmountsQueryKey = (options?: Options<GetInvoicesOutstandingAmountsData>) => createQueryKey('getInvoicesOutstandingAmounts', options);

/**
 * Get the outstanding amounts for a charge system
 */
export const getInvoicesOutstandingAmountsQueryOptions = (options?: Options<GetInvoicesOutstandingAmountsData>) => queryOptions<GetInvoicesOutstandingAmountsResponse, DefaultError, GetInvoicesOutstandingAmountsResponse, ReturnType<typeof getInvoicesOutstandingAmountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvoicesOutstandingAmounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvoicesOutstandingAmountsQueryKey(options)
});

/**
 * Get the outstanding amounts for a charge system
 */
export const useGetInvoicesOutstandingAmountsQuery = (options?: Options<GetInvoicesOutstandingAmountsData>) => useQuery(getInvoicesOutstandingAmountsQueryOptions(options));

export const getInvoiceQueryKey = (options: Options<GetInvoiceData>) => createQueryKey('getInvoice', options);

/**
 * Get the details of an invoice in a charge system
 */
export const getInvoiceQueryOptions = (options: Options<GetInvoiceData>) => queryOptions<GetInvoiceResponse, DefaultError, GetInvoiceResponse, ReturnType<typeof getInvoiceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvoice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvoiceQueryKey(options)
});

/**
 * Get the details of an invoice in a charge system
 */
export const useGetInvoiceQuery = (options: Options<GetInvoiceData>) => useQuery(getInvoiceQueryOptions(options));

export const checkInviteQueryKey = (options: Options<CheckInviteData>) => createQueryKey('checkInvite', options);

/**
 * check if token is valid and if admin exists
 */
export const checkInviteQueryOptions = (options: Options<CheckInviteData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof checkInviteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkInvite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkInviteQueryKey(options)
});

/**
 * check if token is valid and if admin exists
 */
export const useCheckInviteQuery = (options: Options<CheckInviteData>) => useQuery(checkInviteQueryOptions(options));

export const listConnectorStatusesQueryKey = (options?: Options<ListConnectorStatusesData>) => createQueryKey('listConnectorStatuses', options);

/**
 * List connector statuses
 *
 * List all connectors with status and error information that the admin has access to
 */
export const listConnectorStatusesQueryOptions = (options?: Options<ListConnectorStatusesData>) => queryOptions<ListConnectorStatusesResponse2, DefaultError, ListConnectorStatusesResponse2, ReturnType<typeof listConnectorStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConnectorStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConnectorStatusesQueryKey(options)
});

/**
 * List connector statuses
 *
 * List all connectors with status and error information that the admin has access to
 */
export const useListConnectorStatusesQuery = (options?: Options<ListConnectorStatusesData>) => useQuery(listConnectorStatusesQueryOptions(options));

/**
 * Logs in current admin
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<unknown, DefaultError, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Logs in current admin
 */
export const useLoginMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<LoginData>>, 'mutationFn'>>) => useMutation({ ...loginMutation(), ...mutationOptions });

export const getOrganizationAdminsQueryKey = (options: Options<GetOrganizationAdminsData>) => createQueryKey('getOrganizationAdmins', options);

/**
 * List admins related to an organization
 */
export const getOrganizationAdminsQueryOptions = (options: Options<GetOrganizationAdminsData>) => queryOptions<GetOrganizationAdminsResponse, DefaultError, GetOrganizationAdminsResponse, ReturnType<typeof getOrganizationAdminsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationAdmins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationAdminsQueryKey(options)
});

/**
 * List admins related to an organization
 */
export const useGetOrganizationAdminsQuery = (options: Options<GetOrganizationAdminsData>) => useQuery(getOrganizationAdminsQueryOptions(options));

export const getOrganizationInvitedAdminsQueryKey = (options: Options<GetOrganizationInvitedAdminsData>) => createQueryKey('getOrganizationInvitedAdmins', options);

/**
 * List invited admins related to an organization
 */
export const getOrganizationInvitedAdminsQueryOptions = (options: Options<GetOrganizationInvitedAdminsData>) => queryOptions<GetOrganizationInvitedAdminsResponse, DefaultError, GetOrganizationInvitedAdminsResponse, ReturnType<typeof getOrganizationInvitedAdminsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationInvitedAdmins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationInvitedAdminsQueryKey(options)
});

/**
 * List invited admins related to an organization
 */
export const useGetOrganizationInvitedAdminsQuery = (options: Options<GetOrganizationInvitedAdminsData>) => useQuery(getOrganizationInvitedAdminsQueryOptions(options));

/**
 * Change availability
 *
 * Change availability for connectors
 */
export const changeAvailabilityForConnectorsMutation = (options?: Partial<Options<ChangeAvailabilityForConnectorsData>>): UseMutationOptions<unknown, DefaultError, Options<ChangeAvailabilityForConnectorsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ChangeAvailabilityForConnectorsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeAvailabilityForConnectors({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change availability
 *
 * Change availability for connectors
 */
export const useChangeAvailabilityForConnectorsMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<ChangeAvailabilityForConnectorsData>>, 'mutationFn'>>) => useMutation({ ...changeAvailabilityForConnectorsMutation(), ...mutationOptions });

export const getReportQueryKey = (options: Options<GetReportData>) => createQueryKey('getReport', options);

/**
 * Get report data for some period
 */
export const getReportQueryOptions = (options: Options<GetReportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportQueryKey(options)
});

/**
 * Get report data for some period
 */
export const useGetReportQuery = (options: Options<GetReportData>) => useQuery(getReportQueryOptions(options));

/**
 * Create Visitor RFID-key user on organization level
 */
export const createRfidMutation = (options?: Partial<Options<CreateRfidData>>): UseMutationOptions<unknown, DefaultError, Options<CreateRfidData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateRfidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createRfid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Visitor RFID-key user on organization level
 */
export const useCreateRfidMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<CreateRfidData>>, 'mutationFn'>>) => useMutation({ ...createRfidMutation(), ...mutationOptions });

/**
 * Delete Visitor RFID from organization
 */
export const deleteRfidMutation = (options?: Partial<Options<DeleteRfidData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteRfidData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteRfidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRfid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Visitor RFID from organization
 */
export const useDeleteRfidMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<DeleteRfidData>>, 'mutationFn'>>) => useMutation({ ...deleteRfidMutation(), ...mutationOptions });

/**
 * Alter Visitor RFID-key user access on organization level
 */
export const alterRfidAccessMutation = (options?: Partial<Options<AlterRfidAccessData>>): UseMutationOptions<unknown, DefaultError, Options<AlterRfidAccessData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AlterRfidAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await alterRfidAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Alter Visitor RFID-key user access on organization level
 */
export const useAlterRfidAccessMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<AlterRfidAccessData>>, 'mutationFn'>>) => useMutation({ ...alterRfidAccessMutation(), ...mutationOptions });

export const getAutomaticReportsQueryKey = (options: Options<GetAutomaticReportsData>) => createQueryKey('getAutomaticReports', options);

/**
 * Get all automatic reports configurations for an organization
 */
export const getAutomaticReportsQueryOptions = (options: Options<GetAutomaticReportsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getAutomaticReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAutomaticReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAutomaticReportsQueryKey(options)
});

/**
 * Get all automatic reports configurations for an organization
 */
export const useGetAutomaticReportsQuery = (options: Options<GetAutomaticReportsData>) => useQuery(getAutomaticReportsQueryOptions(options));

/**
 * Create a new automatic-report configuration
 */
export const createAutomaticReportMutation = (options?: Partial<Options<CreateAutomaticReportData>>): UseMutationOptions<unknown, DefaultError, Options<CreateAutomaticReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateAutomaticReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAutomaticReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new automatic-report configuration
 */
export const useCreateAutomaticReportMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<CreateAutomaticReportData>>, 'mutationFn'>>) => useMutation({ ...createAutomaticReportMutation(), ...mutationOptions });

/**
 * Delete an automatic report configuration
 */
export const deleteAutomaticReportMutation = (options?: Partial<Options<DeleteAutomaticReportData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteAutomaticReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteAutomaticReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAutomaticReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an automatic report configuration
 */
export const useDeleteAutomaticReportMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<DeleteAutomaticReportData>>, 'mutationFn'>>) => useMutation({ ...deleteAutomaticReportMutation(), ...mutationOptions });

export const getAutomaticReportQueryKey = (options: Options<GetAutomaticReportData>) => createQueryKey('getAutomaticReport', options);

/**
 * Get a single automatic report configuration for an organization
 */
export const getAutomaticReportQueryOptions = (options: Options<GetAutomaticReportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getAutomaticReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAutomaticReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAutomaticReportQueryKey(options)
});

/**
 * Get a single automatic report configuration for an organization
 */
export const useGetAutomaticReportQuery = (options: Options<GetAutomaticReportData>) => useQuery(getAutomaticReportQueryOptions(options));

/**
 * Update automatic report configuration
 */
export const updateAutomaticReportMutation = (options?: Partial<Options<UpdateAutomaticReportData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateAutomaticReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateAutomaticReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAutomaticReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update automatic report configuration
 */
export const useUpdateAutomaticReportMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<UpdateAutomaticReportData>>, 'mutationFn'>>) => useMutation({ ...updateAutomaticReportMutation(), ...mutationOptions });

/**
 * Update connector groups
 *
 * Update charge system connector groups
 */
export const updateConnectorGroupsMutation = (options?: Partial<Options<UpdateConnectorGroupsData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateConnectorGroupsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateConnectorGroupsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConnectorGroups({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update connector groups
 *
 * Update charge system connector groups
 */
export const useUpdateConnectorGroupsMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<UpdateConnectorGroupsData>>, 'mutationFn'>>) => useMutation({ ...updateConnectorGroupsMutation(), ...mutationOptions });

/**
 * Create connector group
 *
 * Create a charge system connector group
 */
export const createConnectorGroupMutation = (options?: Partial<Options<CreateConnectorGroupData>>): UseMutationOptions<unknown, DefaultError, Options<CreateConnectorGroupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateConnectorGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createConnectorGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create connector group
 *
 * Create a charge system connector group
 */
export const useCreateConnectorGroupMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<CreateConnectorGroupData>>, 'mutationFn'>>) => useMutation({ ...createConnectorGroupMutation(), ...mutationOptions });

/**
 * Remove connector group and all its associations
 */
export const deleteConnectorGroupMutation = (options?: Partial<Options<DeleteConnectorGroupData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteConnectorGroupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteConnectorGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteConnectorGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove connector group and all its associations
 */
export const useDeleteConnectorGroupMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<DeleteConnectorGroupData>>, 'mutationFn'>>) => useMutation({ ...deleteConnectorGroupMutation(), ...mutationOptions });

/**
 * Update connector group
 *
 * Update a charge system connector group
 */
export const updateConnectorGroupMutation = (options?: Partial<Options<UpdateConnectorGroupData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateConnectorGroupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateConnectorGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConnectorGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update connector group
 *
 * Update a charge system connector group
 */
export const useUpdateConnectorGroupMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<UpdateConnectorGroupData>>, 'mutationFn'>>) => useMutation({ ...updateConnectorGroupMutation(), ...mutationOptions });

export const startPingChargerQueryKey = (options?: Options<StartPingChargerData>) => createQueryKey('startPingCharger', options);

/**
 * Starts or extends a ping period session for a connector's chargePoint. This will ensure that websocketOffline status is up-to-date.
 */
export const startPingChargerQueryOptions = (options?: Options<StartPingChargerData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof startPingChargerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await startPingCharger({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: startPingChargerQueryKey(options)
});

/**
 * Starts or extends a ping period session for a connector's chargePoint. This will ensure that websocketOffline status is up-to-date.
 */
export const useStartPingChargerQuery = (options?: Options<StartPingChargerData>) => useQuery(startPingChargerQueryOptions(options));

export const stopPingChargerQueryKey = (options?: Options<StopPingChargerData>) => createQueryKey('stopPingCharger', options);

/**
 * Stops an ongoing ping period session
 */
export const stopPingChargerQueryOptions = (options?: Options<StopPingChargerData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof stopPingChargerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stopPingCharger({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stopPingChargerQueryKey(options)
});

/**
 * Stops an ongoing ping period session
 */
export const useStopPingChargerQuery = (options?: Options<StopPingChargerData>) => useQuery(stopPingChargerQueryOptions(options));

export const getReportsQueryKey = (options?: Options<GetReportsData>) => createQueryKey('getReports', options);

/**
 * get report data for multiple chargesystems for a period
 */
export const getReportsQueryOptions = (options?: Options<GetReportsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportsQueryKey(options)
});

/**
 * get report data for multiple chargesystems for a period
 */
export const useGetReportsQuery = (options?: Options<GetReportsData>) => useQuery(getReportsQueryOptions(options));

export const getPassTokenValidQueryKey = (options: Options<GetPassTokenValidData>) => createQueryKey('getPassTokenValid', options);

export const getPassTokenValidQueryOptions = (options: Options<GetPassTokenValidData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getPassTokenValidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPassTokenValid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPassTokenValidQueryKey(options)
});

export const useGetPassTokenValidQuery = (options: Options<GetPassTokenValidData>) => useQuery(getPassTokenValidQueryOptions(options));

export const passWordResetMutation = (options?: Partial<Options<PassWordResetData>>): UseMutationOptions<unknown, DefaultError, Options<PassWordResetData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PassWordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passWordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usePassWordResetMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<PassWordResetData>>, 'mutationFn'>>) => useMutation({ ...passWordResetMutation(), ...mutationOptions });

export const createTokenMutation = (options?: Partial<Options<CreateTokenData>>): UseMutationOptions<unknown, DefaultError, Options<CreateTokenData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const useCreateTokenMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<CreateTokenData>>, 'mutationFn'>>) => useMutation({ ...createTokenMutation(), ...mutationOptions });

export const getRfidUsersQueryKey = (options?: Options<GetRfidUsersData>) => createQueryKey('getRfidUsers', options);

/**
 * Get all Visitor RFID-key users
 */
export const getRfidUsersQueryOptions = (options?: Options<GetRfidUsersData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getRfidUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRfidUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRfidUsersQueryKey(options)
});

/**
 * Get all Visitor RFID-key users
 */
export const useGetRfidUsersQuery = (options?: Options<GetRfidUsersData>) => useQuery(getRfidUsersQueryOptions(options));

/**
 * Update Vistor RFID Key name
 */
export const editRfidKeyNameMutation = (options?: Partial<Options<EditRfidKeyNameData>>): UseMutationOptions<unknown, DefaultError, Options<EditRfidKeyNameData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EditRfidKeyNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editRfidKeyName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Vistor RFID Key name
 */
export const useEditRfidKeyNameMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<EditRfidKeyNameData>>, 'mutationFn'>>) => useMutation({ ...editRfidKeyNameMutation(), ...mutationOptions });

/**
 * Accept an admin to a chargesystem
 */
export const acceptAdminsToChargeSystemMutation = (options?: Partial<Options<AcceptAdminsToChargeSystemData>>): UseMutationOptions<unknown, DefaultError, Options<AcceptAdminsToChargeSystemData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AcceptAdminsToChargeSystemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptAdminsToChargeSystem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept an admin to a chargesystem
 */
export const useAcceptAdminsToChargeSystemMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, DefaultError, Options<AcceptAdminsToChargeSystemData>>, 'mutationFn'>>) => useMutation({ ...acceptAdminsToChargeSystemMutation(), ...mutationOptions });

export const getP3UsersQueryKey = (options?: Options<GetP3UsersData>) => createQueryKey('getP3Users', options);

/**
 * Get all app users
 */
export const getP3UsersQueryOptions = (options?: Options<GetP3UsersData>) => queryOptions<GetP3UsersResponse, GetP3UsersError, GetP3UsersResponse, ReturnType<typeof getP3UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getP3Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getP3UsersQueryKey(options)
});

/**
 * Get all app users
 */
export const useGetP3UsersQuery = (options?: Options<GetP3UsersData>) => useQuery(getP3UsersQueryOptions(options));

export const getP3UserQueryKey = (options: Options<GetP3UserData>) => createQueryKey('getP3User', options);

/**
 * Get app user by id in a charge system
 */
export const getP3UserQueryOptions = (options: Options<GetP3UserData>) => queryOptions<GetP3UserResponse, GetP3UserError, GetP3UserResponse, ReturnType<typeof getP3UserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getP3User({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getP3UserQueryKey(options)
});

/**
 * Get app user by id in a charge system
 */
export const useGetP3UserQuery = (options: Options<GetP3UserData>) => useQuery(getP3UserQueryOptions(options));

export const getVariablesQueryKey = (options: Options<GetVariablesData>) => createQueryKey('getVariables', options);

/**
 * get cp config
 *
 * get configuration of chargepoint
 */
export const getVariablesQueryOptions = (options: Options<GetVariablesData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getVariablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVariables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVariablesQueryKey(options)
});

/**
 * get cp config
 *
 * get configuration of chargepoint
 */
export const useGetVariablesQuery = (options: Options<GetVariablesData>) => useQuery(getVariablesQueryOptions(options));
